import React from 'react';
import PropTypes from 'prop-types';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core';

const wrapWithSortLabel = (props, columnHeader) => {
  return (
    <TableSortLabel
      active={
        !!columnHeader.isSortedBy && !!columnHeader.sortBy
          ? columnHeader.isSortedBy()
          : false
      }
      direction={props.direction || 'desc'}
      onClick={columnHeader.onRequestSort}
    >
      {columnHeader.display}
    </TableSortLabel>
  );
};

const DataTableHeader = (props) => {
  return (
    <TableHead>
      <TableRow>
        {props.columnHeaders.map((columnHeader, index) => {
          return (
            <TableCell
              key={index}
              align={columnHeader.isNumeric ? 'right' : 'inherit'}
              padding="default"
              className={columnHeader.className}
            >
              {wrapWithSortLabel(props, columnHeader)}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

DataTableHeader.propTypes = {
  columnHeaders: PropTypes.array.isRequired,
  direction: PropTypes.string
};

export default DataTableHeader;
